import { required, optional } from 'AppReact/schema';

export default {
    cardNumber: required('string'),
    expiration: required('string'),
    cardCode: required('string'),
    fullName: required('string'),
    zip: required('string'),
    IsAdminFeePaid: optional('boolean'),

    cardNumberError: optional('string'),
    expirationError: optional('string'),
    cardCodeError: optional('string'),
    fullNameError: optional('string'),
    zipError: optional('string'),
}


export const defaultCardDetails = {
    focusedField: '',
    cardNumber: '',
    expiration: '',
    cardCode: '',
    fullName: '',
    zip: '',
    IsAdminFeePaid: true,

    cardNumberError: '',
    expirationError: '',
    cardCodeError: '',
    fullNameError: '',
    zipError: '',
}
